import React from 'react';
import { useTranslation } from 'react-i18next';

import { LangNamespaceEnum } from 'shared/enums/LangNamespaceEnum';

import { SkipLinkAnchor } from './SkipToContentLink.s';

export type SkipToContentLinkProps = {
  targetId: string;
};

export const SkipToContentLink: React.VFC<SkipToContentLinkProps> = ({ targetId }) => {
  const { t } = useTranslation(LangNamespaceEnum.SURVEY_UI_COMPONENTS);

  return (
    <SkipLinkAnchor href={`#${targetId}`}>{t('SkipToContentLink.skipToContent')}</SkipLinkAnchor>
  );
};
